// extracted by mini-css-extract-plugin
module.exports = {"ContactInfo":"ContactInfo_ContactInfo__3Pn50","ContactInfoText":"ContactInfo_ContactInfoText__1yVwK"};